module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "aria-label": "Epigraph"
    }
  }, [_c('blockquote', {
    staticClass: "epigraph"
  }, [_c('p', {
    staticClass: "epitxt"
  }, [_c('span', {
    attrs: {
      "aria-label": "page ix",
      "id": "page_ix",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": "page x",
      "id": "page_x",
      "role": "doc-pagebreak"
    }
  }, [_c('b', [_vm._v("F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OR")]), _vm._v(", "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IN THE FINAL ANALYSIS")]), _vm._v(",")])])])]), _vm._v(" "), _c('p', {
    staticClass: "epitxt"
  }, [_c('i', [_vm._v("our most basic common link")])]), _vm._v(" "), _c('p', {
    staticClass: "epitxt"
  }, [_c('b', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IS THAT WE ALL INHABIT")])])]), _vm._v(" "), _c('p', {
    staticClass: "epitxt"
  }, [_c('i', [_vm._v("this small planet.")])]), _vm._v(" "), _c('p', {
    staticClass: "epitxt"
  }, [_c('b', [_vm._v("W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("E ALL BREATHE THE SAME AIR")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "epitxt"
  }, [_c('i', [_vm._v("We all cherish our children’s future.")])]), _vm._v(" "), _c('p', {
    staticClass: "epitxt"
  }, [_c('b', [_vm._v("A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ND WE ARE ALL MORTAL")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "epinam"
  }, [_vm._v("—John F. Kennedy")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38a2b784","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781481403887/xhtml/epigraph.vue
// module id = 69
// module chunks = 0